import * as React from "react";
import { notifications } from "@mantine/notifications";
import Icon from "components/common/Icon/Icon";
import { singleton } from "logic/singleton";
const UserNotification = {
  error(message, title = "Error") {
    notifications.show({
      message,
      title,
      autoClose: 1e4,
      color: "red",
      icon: /* @__PURE__ */ React.createElement(Icon, { name: "exclamation", type: "regular" })
    });
  },
  warning(message, title = "Attention") {
    notifications.show({
      message,
      title,
      color: "blue",
      icon: /* @__PURE__ */ React.createElement(Icon, { name: "exclamation", type: "regular", rotation: 180 })
    });
  },
  success(message, title = "Success") {
    notifications.show({
      message,
      title,
      color: "green",
      icon: /* @__PURE__ */ React.createElement(Icon, { name: "check", type: "regular" })
    });
  }
};
export default singleton("core.UserNotification", () => UserNotification);
